import { getElement } from "@/services/dom";

import type { Location } from "@/types";
import type { Ref } from "vue";

export function setInnosendValues(currentLocation: Ref<Location | null>, courier?: string) {
	if (window.setInnosendValues) {
		window.setInnosendValues(currentLocation.value?.id ?? "", courier ?? "", JSON.stringify(currentLocation.value));
	}

	getElement("#innosend_courier_id", document)?.setAttribute("value", currentLocation.value?.id ?? "");
	getElement("#innosend_courier_name", document)?.setAttribute("value", courier ?? "");
	getElement("#innosend_location_data", document)?.setAttribute("value", JSON.stringify(currentLocation.value));
}
